<template>
  <h3 class="body-1-bold my-24">
    {{ i18n(translations.title) }}
  </h3>

  <ul class="mb-24 list-none space-y-12">
    <li v-for="address in addresses" :key="address.id">
      <RevRadio
        :id="address.id"
        v-model="selectedAddress"
        :value="address.id"
        variant="full"
      >
        <template #label>
          {{ address.label }}
        </template>

        <template #description>
          <div class="body-1">{{ address.company }}</div>
          <div class="body-1">{{ address.addressLine }}</div>
          <div class="body-1">{{ address.addressLine2 }}</div>
          <div class="body-1">
            {{ address.postalCode + ' ' + address.city }}
          </div>
          <div class="body-1">{{ address.state }}</div>
          <div class="body-1">{{ i18n.country(address.country) }}</div>
        </template>
      </RevRadio>
    </li>
  </ul>

  <RevButton
    class="mt-auto"
    :disabled="isDisabled"
    full-width="always"
    type="submit"
    variant="primary"
    @click="goToNextStep"
  >
    {{ i18n(translations.cta) }}
  </RevButton>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { merchantsAPI } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevRadio } from '@ds/components/Radio'

import translations from './AddressSelection.translations'

const { addresses, defaultValue } = defineProps<{
  addresses: merchantsAPI.Address[] | undefined
  defaultValue: string
}>()
const emit = defineEmits(['next-step'])

const i18n = useI18n()
const selectedAddress = ref(defaultValue || false)

const isDisabled = computed(() => !selectedAddress.value)

function goToNextStep() {
  emit('next-step', {
    addressId: selectedAddress.value,
  })
}
</script>
